import React, { useState } from "react";
import { CaretDown } from '../../icons/icons';
import { Collapse } from 'react-collapse';

const Filter = props => {
  const [isOpen, setIsOpen] = useState(props.isOpen ? true : false);

  const handleCollapseToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <button onClick={handleCollapseToggle} className={`btn product-finder-aside__toggle ${isOpen ? 'is-open' : ''}`}>
        <dl>
          <dt>{ props.label }</dt>
          <dd>
            <CaretDown />
          </dd>
        </dl>
      </button>
      <Collapse isOpened={isOpen}>
        { props.children }
      </Collapse>
    </div>
  );
};

export default Filter;
